import React from 'react';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Date, EAA_ErrorText, EAA_Upload } from '~/components/EditAndAddItem';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import * as getTime from '~/skills/getTime';

const ReviewMeet = ({ titleWidth, disabled, checkChange, data, changeData, errorAry, errorLeft }) => {
  const ary = [
    <EAA_Row key='Page_ForeignBoat_ReviewMeet_1'>
      <EAA_Item>
        <EAA_ItemContainer>
          <EAA_TitleText width={titleWidth} text='' />
          <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>會議日期</div>
          <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>上傳會議紀要函文</div>
          <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 + 150 }}>通過與否</div>
        </EAA_ItemContainer>
      </EAA_Item>
    </EAA_Row>,
    <EAA_Row style={{ marginTop: 0 }} key='Page_ForeignBoat_ReviewMeet_2'>
      <EAA_Item>
        <EAA_ItemContainer>
          <EAA_TitleText width={titleWidth} text='審查會議' haveChange={checkChange('review_date') || checkChange('is_review')} />
          <EAA_Date displayBorder disabled={disabled} marginRight={8} value={getTime.returnDate(data.review_date)} onChange={data => changeData({ label: 'review_date', data: getTime.getType3Time(data) })} />
          <EAA_Upload displayBorder disabled={disabled} marginRight={8} value={data.review_upload_files || []} onChange={data => changeData({ label: 'review_upload_files', data })} />
          <div style={{ flex: 1, marginRight: 8, display: 'flex' }}>
            <CircleCheckBox disabled={disabled} value={data.is_review === '1'} onClick={() => changeData({ label: 'is_review', data: '1' })} />
            <div style={{ marginRight: 8 }}>不通過</div>
            <CircleCheckBox disabled={disabled} value={data.is_review === '2'} onClick={() => changeData({ label: 'is_review', data: '2' })} />
            <div>通過</div>
          </div>
          <div style={{ width: 150 }} />
        </EAA_ItemContainer>
        {errorAry[13] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇『會議日期』' />}
        {errorAry[14] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳『會議紀要函文』' />}
        {errorAry[15] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選『通過與否』' />}
      </EAA_Item>
    </EAA_Row>,
  ];
  return ary;
};
export default ReviewMeet;
